"use client"

import { track } from "@vercel/analytics/react"

import { BoilerplateCardContent } from "./boilerplate-card"
import { BoilerplateWithVotes } from "./sections/boilerplate-list"

// Usefull for tracking clicks on boilerplates (🚧 use only in featured!!)
export default function BoilerplateCardContentClient({
  boilerplate,
  avatarSize = "sm",
}: {
  boilerplate: Partial<BoilerplateWithVotes>
  avatarSize?: "sm" | "md" | "lg"
}) {
  return (
    <BoilerplateCardContent
      onClick={() => {
        track("featured_click", {
          boilerplateId: boilerplate.id ?? "",
        })
      }}
      boilerplate={boilerplate}
      avatarSize={avatarSize}
    />
  )
}
